import { create } from 'zustand';

interface ViewRepliesModalStore {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const useViewRepliesModalAgent = create<ViewRepliesModalStore>(set => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}));

export default useViewRepliesModalAgent;
